import { FeatureFlags, PermissionCategoriesNames, PermissionEntitiesNames } from '@fabric-ui/components';
import { PAGE_PATHS } from './routes.types';

export { PermissionEntitiesNames, Permission, PermissionAppName, PermissionModelEntityName } from '@fabric-ui/components';
export type { PermissionCategoriesNames } from '@fabric-ui/components';

export const INTERNAL_ROLES = {
  RND_ADMIN: 'RND_ADMIN',
  SYS_ADMIN: 'SYS_ADMIN',
  RISK360_RND_ADMIN: 'RISK360_RND_ADMIN',
  RISK360_SUPPORT_ADMIN: 'RISK360_SUPPORT_ADMIN',
};

// TODO: cleanup after permissions is fully migrated
export const ROLES = {
  RND_ADMIN: 7,
  ADMIN: 5,
  EDITOR: 4,
  VIEWER: 3,
  SIEM_USER: 2,
  PRE_POV: 1,
  SYS_ADMIN: 18,
};

export const getRoleNameByValue = value => Object.keys(ROLES).find(key => ROLES[key] === value);

export const OLD_PREDEFINED_ROLE_NAMES = {
  EDITOR: 'EDITOR',
  VIEWER: 'VIEWER',
  SIEM_USER: 'SIEM_USER',
};

export const NEW_PREDEFINED_ROLE_NAMES = { DEFAULT: 'DEFAULT', RND_ADMIN: 'RND_ADMIN', ADMIN: 'ADMIN' };
export const PREDEFINED_ROLE_NAMES = { ...OLD_PREDEFINED_ROLE_NAMES, ...NEW_PREDEFINED_ROLE_NAMES };

export type FeatureFlagValue = (typeof FeatureFlags)[keyof typeof FeatureFlags];

export const PathFeatureFlag = {
  [PAGE_PATHS.DATA_PURGE]: FeatureFlags.EnableDataRetentionDefaultRulesCreation,
  [PAGE_PATHS.ACCOUNT_USAGE]: FeatureFlags.accountUsagePage,
  [PAGE_PATHS.AUTHENTICATION_SOURCES]: FeatureFlags.OneAuthUI,
  [PAGE_PATHS.SCANNERS_ACTIVATION]: FeatureFlags.ScannersActivation,
  [PAGE_PATHS.EASM_SETTINGS]: FeatureFlags.ShowAssetDiscoveryPage,
  [PAGE_PATHS.RISK_SCORE]: FeatureFlags.AssetRiskScore,
  [PAGE_PATHS.AGENTS]: FeatureFlags.AgentDashboard,
  [PAGE_PATHS.AGENTIC_SOC]: FeatureFlags.ShowIncidentFlow,
  [PAGE_PATHS.SOC_AUTOMATIONS]: FeatureFlags.ShowAutomations,
  [PAGE_PATHS.INCIDENT_LIFECYCLE]: FeatureFlags.IncidentLifecycle,
  [PAGE_PATHS.ENTITIES_TO_LOGS]: FeatureFlags.LogsEntities,
  [PAGE_PATHS.RISK_SCORE]: FeatureFlags.AssetRiskScore,
};

export type PermissionForRoute =
  | {
      category?: PermissionCategoriesNames;
      permissionEntity: PermissionEntitiesNames;
    }
  | { requiredRole: keyof typeof PREDEFINED_ROLE_NAMES };
